import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <img 
              src="/images/logo.png" 
              alt="ACT PAWS Logo" 
              className="h-10 w-auto object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-semibold text-sm transition-colors duration-200 ${
                isActive('/')
                  ? 'text-primary border-b-2 border-primary pb-1'
                  : 'text-gray-700 hover:text-primary'
              }`}
            >
              Home
            </Link>
            <Link
              to="/contact"
              className={`font-semibold text-sm transition-colors duration-200 ${
                isActive('/contact')
                  ? 'text-primary border-b-2 border-primary pb-1'
                  : 'text-gray-700 hover:text-primary'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/privacy-policy"
              className={`font-semibold text-sm transition-colors duration-200 ${
                isActive('/privacy-policy')
                  ? 'text-primary border-b-2 border-primary pb-1'
                  : 'text-gray-700 hover:text-primary'
              }`}
            >
              Privacy
            </Link>
            <Link
              to="/terms-and-conditions"
              className={`font-semibold text-sm transition-colors duration-200 ${
                isActive('/terms-and-conditions')
                  ? 'text-primary border-b-2 border-primary pb-1'
                  : 'text-gray-700 hover:text-primary'
              }`}
            >
              Terms
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-3 border-t border-gray-100">
            <Link
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg font-semibold transition-colors ${
                isActive('/')
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Home
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg font-semibold transition-colors ${
                isActive('/contact')
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/privacy-policy"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg font-semibold transition-colors ${
                isActive('/privacy-policy')
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Privacy
            </Link>
            <Link
              to="/terms-and-conditions"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg font-semibold transition-colors ${
                isActive('/terms-and-conditions')
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Terms
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
